class BESSAppProjectCreditManager extends BESSAppBase {

    constructor() {
        super();
        let creditNodes = $('.app-credit');
        this.creditsSection = $('.app-category-credits');
        this.credits = _.map(creditNodes, node => new BESSAppProjectCredit($(node)));
    }

    credit(code) {
        return _.find(this.credits, (credit) => credit.code === code);
    }

    start() {
        this.log('Loaded', this);
        this.forEach(this.credits, (x) => x.start());

        this.setupCreditSectionDependencies()
    }

    setupCreditSectionDependencies() {
        let dependencies = [];
        this.forEach(BESSApp.instance.managers.profilers.profilers, function (profiler) {
            if (profiler.data.creditSectionDependencies.length > 0) {
                this.log('add dependencies', {
                    'profiler': profiler,
                });
                this.forEach(profiler.data.creditSectionDependencies, function (dependency) {
                    dependencies.push(dependency);
                });
            }
        });

        if (dependencies.length > 0) {
            new BESSAppDependentView(this.creditsSection, dependencies);
        }
    }
}